import React from 'react'
import { StateProvider } from '../state'
import ActivityTablesContainer from './ActivityTablesContainer'
import PropTypes from 'prop-types'

const App = props => {
  const initialState = {
    course: props.course,
    groups: props.data.groups,
    courseData: props.data.courseData,
    proxyUser: props.proxyUser,
  }
  return (
    <StateProvider initialState={initialState}>
      <div className="container-fluid">
        <h1
          className="me-course-title"
          dangerouslySetInnerHTML={{ __html: props.course }}
        />
        {props.proxyUser ? (
          <h2 className="me-page-title">
            Assessments: {props.proxyUser.replace('&#39;', "'")}
          </h2>
        ) : (
          <h2 className="me-page-title">Assessments</h2>
        )}
        <ActivityTablesContainer />
      </div>
    </StateProvider>
  )
}

export default App

App.propTypes = {
  course: PropTypes.string,
  data: PropTypes.object,
  proxyUser: PropTypes.string,
}
